//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'

export default {
  data () {
    return {
      index: 0,
      hasJDCard: false,
      jdCardValue: '0元京东卡',
      inActivity: false,
      activityId: '151019418799579',
      recommendProducts: [],
      showAct: false,
      actURL: '',
      careValue: '',
      points: ''
    }
  },
  computed: {
    /**
     * 泓华
     * 并且是孝亲宝和百年人寿重疾
     * 151081379844957222
     * 151029685664879251
     * 'xiaoqinbao': [ // 孝亲宝
        '150831059068987214', // 测试
        '150840325766681140'
      ],
      'aeonlife-zhongji': [ // 百年人寿重疾 - 轻症豁免版
        '150476691002746473',
        '150537492578996275',
        '150572818874302097', // 仅用于秒杀，测试
        '150572806361984311' // 仅用于秒杀，正式
      ],
     */
    isHH () {
      let ishh = false
      if (['151081379844957222', '151029685664879251'].indexOf(this.$store.state.app.innerCode) !== -1) { // 泓华
        ishh = true
      }
      let isNeededProduct = false
      if (['150831059068987214', '150840325766681140', '150476691002746473', '150537492578996275'].indexOf(this.$store.state.app.productCode) !== -1) { // 孝亲宝 百年人寿轻症豁免版
        isNeededProduct = true
      }
      if (ishh && isNeededProduct) {
        return true
      }
      return false
    },
    isWKB () {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) === -1) { // 是悟空保
        return false
      }
      if (['150476691002746473', '150537492578996275', '150831059068987214', '150840325766681140'].indexOf(this.$store.state.app.productCode) === -1) { // 过滤产品
        return false
      }
      return true
    },
    activity1111DrawURL () {
      return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2017/1111-draw'
    },
    h5 () {
      return this.$store.state.app.h5
    },
    swiperList () {
      const productCodes = [
        '149559395942738681', // 终身重疾 测试
        '149614236499831794',
        '149301981977264138', // 百医百顺 测试
        '149421366832021029',
        '149146529095616548', // 终身寿险 测试
        '149251955998404923',
        '149173252548863780', // 终身意外 测试
        '149329577605090390'
        // '152411995379088878', // 紫霞宝 测试
        // '152524346503451854'
      ]
      const list = []
      this.recommendProducts.forEach((ele) => {
        const tEle = Object.assign({}, ele)
        if (window.location.hostname === 'test.m.wkbins.com' || window.location.hostname === 'test1.m.wkbins.com') {
          tEle.productCode = tEle.testProductCode
        }
        // 如果是当前产品，则不再推荐
        if (tEle.productCode === this.$store.state.app.productCode) return
        // 产品的URL分两类，根据productCode判断
        let url = ''
        if (productCodes.indexOf(tEle.productCode) !== -1) {
          url = window.location.protocol + '//' + window.location.host + '/illness/insurePolicy/' + this.$store.state.app.innerCode + '/' + tEle.productCode + '?requireJsApi=true'
        } else {
          let xPath = 'explosions'
          if (['149673981474815463', '149674766585200396'].indexOf(ele.productCode) !== -1) xPath = 'hengqin' // 横琴定期寿险
          if (['149792907872138096', '149792885824813849'].indexOf(ele.productCode) !== -1) xPath = 'hqdy' // 横琴定期意外险
          url = window.location.protocol + '//' + window.location.host + '/' + xPath + '/?r=' + Math.random() + '/#/' + this.$store.state.app.innerCode + '/' + tEle.productCode + '?' + qs.stringify(this.$route.query)
        }
        tEle.url = url
        list.push(tEle)
      })
      return list
    },
    resultNotices () {
      if (this.$store.state.order.confirmFeedback) {
        return this.$store.state.config.resultNoticesOK || this.$store.state.config.resultNotices
      }
      return this.$store.state.config.resultNoticesFalse || this.$store.state.config.resultNotices
    },
    lastNoticeIndex () {
      if (this.resultNotices) return this.resultNotices.length + 1
    }
  },
  created () {
    document.title = '提交详情'

    // 产品推荐的数据
    this.$http.get(window.location.protocol + '//' + window.location.host + (window.location.pathname === '/' ? '' : window.location.pathname) + '/static/common/js/recommendProducts.json').then((response) => {
      response.data.forEach((ele) => {
        this.recommendProducts.push(ele)
      })
    })

    delete this.$route.query.activityCode

    // 判断活动是否可用
    this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(response => {
      if (response.data.resultCode === 'error') {
        this.inActivity = false
      } else {
        this.inActivity = true
      }
    })

    // 京东卡
    this.$http.get('/api/activity/getDiscountInfoByProduct?handOutNode=4&productCode=' + this.$store.state.app.productCode).then((response) => {
      if (response.data.resultCode === 'success') {
        this.hasJDCard = true
        this.jdCardValue = response.data.data
      }
    })

    // 大病医保公益
    const that = this
    ;(() => {
      const start = new Date(2018, 7, 1)
      const end = new Date(2018, 9, 1)
      const now = new Date()
      // 活动期间内显示 C端
      if (now >= start && now <= end && that.isWKB) {
        // ajax请求获取海报
        that.$http.post('/api/dbyb/createQrCode', qs.stringify({
          orderCode: that.$store.state.order.unionCode
        })).then((response) => {
          if (response.data.resultCode === 'success') {
            that.$data.actURL = response.data.result.url
            // 显示海报
            that.$data.showAct = true
          }
        })
      }
    })()
    this.$http.post('/api/cms/product/version', qs.stringify({
      linkedProductCode: this.$store.state.app.productCode,
      unionCode: this.$store.state.order.unionCode
    })).then((response) => {
      if (response.data.resultCode === 'success') {
        this.careValue = response.data.careValue
        this.points = response.data.points
      }
    })
  },
  mounted () {
    // window.jQuery(window).on('popstate', this.go)
    // setTimeout(() => {
    //   this.changeSwiperPositon()
    // }, 500)
    // var _this = this
    // if (this.$store.state.app.innerCode === '148198068433580000') {
    //   var utmSource = _this.$route.query.utm_source
    //   if (!utmSource || utmSource === 'wechat' || utmSource === 'wx') {
    //     utmSource = 'wechat'
    //   }
    //   let orderQuerenURL = '/api/hqdqx/orderQueren/'
    //   if (this.h5) {
    //     orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
    //   }
    //   this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode).then(response => {
    //     window._hmt.push(['_trackOrder', {
    //       'orderId': response.data.busOrder.orderCode,
    //       'orderTotal': response.data.underwritingInfoList[0].premium / 100,
    //       'item': [
    //         {
    //           'skuId': _this.$store.state.app.productCode,
    //           'skuName': response.data.busProductRelation.productName,
    //           'category': utmSource,
    //           'Price': response.data.underwritingInfoList[0].premium / 100,
    //           'Quantity': 1
    //         }
    //       ]}
    //     ])
    //   })
    // }
    // this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=result&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
    // })
  },
  destroyed () {
    window.jQuery(window).off('popstate', this.go)
  },
  methods: {
    go (event) {
      window.history.forward(1)
    },
    changeSwiperPositon () {
      let height = window.jQuery('.vux-slider').height() / 2
      window.jQuery('.left-nav, .right-nav').css({top: height + 'px', opacity: 0.3})
    },
    comment () {
      this.$http.get('/api/hqdqx/findEvaluate/' + this.$store.state.order.unionCode).then(response => {
        if (response.data) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，不能重复评价哦',
            position: 'top',
            width: '20em'
          })
        } else {
          this.$router.push({name: 'Comment', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
        }
      })
    },
    tempHH () {
      window.location.href = 'http://p.oasiscare.cn/mobilefront/index.html'
    },
    isAeonlife () {
      if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Result.vue